var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InputField',{ref:"input",attrs:{"type":"number","field":_vm.field,"field-wrapper":true},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }